export default "__VITE_ASSET__C$cBJGzH__"